<template>
  <div class="page" v-if="can('others.content')">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-open-in-new</v-icon>
      إدارة الروابط الخارجية
      <back-button />
    </h2>
    <hr class="my-5 header-divider" />

    <!-- CREATE / UPDATE FROM -->
    <record-form @update="fetchRecords()" />

    <!-- UPDATE / NEW RECORD -->
    <div class="mb-3 mt-9 text-left">
      <v-btn
        v-if="can('others.content')"
        color="primary"
        elevation="0"
        @click="SET_RECORD_FORM({}); SET_EDIT_MODE(false); SHOW_RECORD_FORM()"
      >
        إضافة رابط
        <v-icon class="mr-2">mdi-plus</v-icon>
      </v-btn>
    </div>

    <!-- TABLE -->
    <v-data-table
      item-key="id"
      class="elevation-1"
      :loading="table.loading"
      :headers="table.headers"
      :items="records"
      loading-text="جاري تحميل البيانات"
      no-data-text="لا يوجد بيانات"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
    >
      <!-- IMAGE -->
      <template v-slot:item.image="{ item }">
        <img
          :src="item.image"
          width="50px"
          class="mt-3 mb-2 ml-2 rounded-lg"
        >
      </template>
      <!-- CONTROLS -->
      <template v-slot:item.controls="{ item }">
        <v-btn
          small
          icon
          color="success"
          class="mx-2"
          @click="SET_RECORD_FORM(item); SET_EDIT_MODE(true); SHOW_RECORD_FORM()"
          v-if="can('others.content')"
        >
          <v-icon>mdi-circle-edit-outline</v-icon>
        </v-btn>

        <v-btn
          v-if="can('others.content')"
          small
          icon
          color="error"
          class="mx-2"
          @click="remove(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- PAGINATION -->
    <div class="text-center mt-7">
      <v-pagination
        total-visible="7"
        circle
        :value="parseInt(filters.page)"
        :length="totalPages"
        @input="$router.replace({ query: { ...$route.query, page: $event } })"
      ></v-pagination>
    </div>
  </div>
</template>


<script>
import RecordForm from './RecordForm';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'external-website-links',
  components: { RecordForm },

  data: function () {
    return {
      table: {
        headers: [
          {
            value: 'id',
            text: 'رقم الرابط'
          },
          {
            value: 'image',
            text: 'الصورة'
          },
          {
            value: 'link',
            text: 'الرابط'
          },
          {
            value: 'created_at',
            text: 'تاريخ الإضافة'
          },
          {
            value: 'controls',
            text: 'اعدادات'
          }
        ],
        loading: false
      }
    }
  },

  computed: {
    ...mapState('externalWebsiteLinks', ['records', 'filters', 'totalPages']
    )
  },


  watch: {
    '$route': {
      async handler(route) {
        if (!route.query.page) {
          await this.$router.replace({ query: { ...route.query, page: 1 } });
          return;
        }

        this.SET_FILTERS(route.query);
        this.fetchRecords();
      },
      deep: true,
      immediate: true,
    }
  },


  methods: {
    ...mapMutations(
      'externalWebsiteLinks',
      [
        'SHOW_RECORD_FORM',
        'SET_EDIT_MODE',
        'SET_RECORD_FORM',

        'SET_CURRNET_RECORD',

        'SET_FILTERS',
      ]
    ),

    fetchRecords() {
      this.table.loading = true;

      this.$store.dispatch('externalWebsiteLinks/fetchRecords')
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب البيانات, يرجي التأكد من حالة الشبكة',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },

    async remove(selectedRecord) {
      const confirmMessageParams = [
        `حذف الرابط رقم ${selectedRecord.id}!`,
        `هل أنت متأكد من حذف الرابط ${selectedRecord.link}؟`,
        { color: 'error' }
      ];
      if (!await this.$root.$confirm(...confirmMessageParams)) return;

      this.table.loading = true;

      this.$store.dispatch('externalWebsiteLinks/delete', { recordId: selectedRecord.id })
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم حذف الرابط بنجاح',
            color: 'success'
          });
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            color: 'accent',
            text: (error.response && error.response.status == 400)
             ? 'تأكد من عدم وجود مواد خاصة بالرابط' 
             : 'تعذر حذف الرابط'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    }
  }
}
</script>
